import { Navigate, useLocation } from 'react-router-dom';
import MarketingLayout from '../components/marketing/MarketingLayout';
import { getMarketingDoc } from '../content/marketing';

export default function MarketingDocPage() {
  const { pathname } = useLocation();
  const doc = getMarketingDoc(pathname);

  if (!doc) {
    return <Navigate to="/landing" replace />;
  }

  return (
    <MarketingLayout title={`${doc.title} | VisiMe`} description={doc.description}>
      <article className="l-page">
        <div className="l-wrap l-page-grid">
          <header className="l-page-head">
            <p className="l-eyebrow">Rechtliches</p>
            <h1 className="l-h2">{doc.title}</h1>
            <p className="l-page-meta">Stand: {doc.updated}</p>
          </header>
          <div className="l-doc">
            {doc.sections.map((section) => (
              <section key={section.heading}>
                <h2>{section.heading}</h2>
                {section.paragraphs?.map((p) => (
                  <p key={p}>{p}</p>
                ))}
                {section.list ? (
                  <ul>
                    {section.list.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                ) : null}
              </section>
            ))}
          </div>
        </div>
      </article>
    </MarketingLayout>
  );
}
